import React from 'react';
import { Box, Typography } from '@mui/material';

interface PasswordMatchIndicatorProps {
  /** Whether password and confirm password values are equal */
  match: boolean;
  /** When true, the match message is shown (e.g. when user has typed in confirm field) */
  show: boolean;
}

/**
 * Displays "✓ Passwords match" or "✗ Passwords do not match" with appropriate styling.
 * Use in Register, CompanySignup, ResetPassword whenever both password and confirm
 * password fields exist.
 */
const PasswordMatchIndicator: React.FC<PasswordMatchIndicatorProps> = ({
  match,
  show,
}) => {
  if (!show) return null;

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      <Typography
        variant="body2"
        sx={{
          color: match ? 'success.main' : 'error.main',
          fontSize: '0.875rem',
          fontWeight: 'medium',
        }}
      >
        {match ? '✓ Passwords match' : '✗ Passwords do not match'}
      </Typography>
    </Box>
  );
};

export default PasswordMatchIndicator;
